import * as BaseApi from "../Base.api";
import { IBbs, IComment } from "../interfaces/bbs.interface";
import { IPagination, ILikeToggleResponse } from "../interfaces/common.interface";

// 매거진 목록 조회
export const getMagazineList = async (params?: any) => {
  const url = "/student/v2/magazine";
  return await BaseApi.get(url, params);
};

// 매거진 상세 조회
export interface IMagazineDetailResponse {
  magazine: IBbs;
}
export const getMagazine = async (id: number): Promise<IMagazineDetailResponse> => {
  const url = `/student/v2/magazine/${id}`;
  return await BaseApi.get(url);
};

// 매거진 좋아요 토글
export interface IToggleMagazineLikeResponse {
  isLiked: boolean;
  likeCount: number;
}
export const toggleMagazineLike = async (id: number): Promise<IToggleMagazineLikeResponse> => {
  const url = `/student/v2/magazine/${id}/like`;
  return await BaseApi.post2(url);
};

// 매거진 댓글 작성
export interface ICreateMagazineCommentResponse {
  comment: IComment;
}
export const createMagazineComment = async (id: number, text: string): Promise<ICreateMagazineCommentResponse> => {
  const url = `/student/v2/magazine/${id}/comment`;
  return await BaseApi.post2(url, { text });
};

// 매거진 댓글 목록 조회
export interface IGetMagazineCommentListResponse {
  commentList: IComment[];
  pagination: IPagination;
}
export const getMagazineCommentList = async (id: number, params?: any): Promise<IGetMagazineCommentListResponse> => {
  const url = `/student/v2/magazine/${id}/comment`;
  return await BaseApi.get(url, params);
};

// Response 인터페이스들
export interface IMagazineListResponse {
  magazineList: IBbs[];
  pagination: IPagination;
}

export interface IMagazineResponse {
  magazine: IBbs;
}

export interface IMagazineCommentListResponse {
  commentList: IComment[];
  pagination: IPagination;
}

export interface ITranslateMagazineResponse {
  translatedTitle: string;
  translatedText: string;
}
export const translateMagazine = async (id: number, params?: any): Promise<ITranslateMagazineResponse> => {
  const url = `/student/v2/magazine/${id}/translate`;
  return await BaseApi.post2(url, params);
};

export interface ITranslateMagazineCommentResponse {
  translatedText: string;
}
export const translateMagazineComment = async (id: number, commentId: number): Promise<ITranslateMagazineCommentResponse> => {
  const url = `/student/v2/magazine/${id}/comment/${commentId}/translate`;
  return await BaseApi.post2(url);
};